import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

interface PlaceholderHelperProps {
  className?: string;
}

const PlaceholderHelper: React.FC<PlaceholderHelperProps> = ({ className = '' }) => {
  const placeholders = [
    {
      name: '[AGENT_NAME]',
      description: 'Replaced with the agent name from the selected conversation style'
    },
    {
      name: '[CUSTOMER_NAME]',
      description: 'Replaced with the lead\'s full name'
    },
    {
      name: '[CUSTOMER_COMPANY]',
      description: 'Replaced with the lead\'s company name (if provided)'
    },
    {
      name: '[YOUR_COMPANY]',
      description: 'Replaced with your organization or campaign company name'
    }
  ];

  return (
    <div className={`bg-blue-50 dark:bg-blue-950/20 border border-blue-200 dark:border-blue-800 rounded-lg p-3 ${className}`}>
      <div className="flex items-start space-x-2">
        <InformationCircleIcon className="h-5 w-5 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <h4 className="text-sm font-medium text-blue-900 dark:text-blue-100 mb-2">
            Available Placeholders
          </h4>
          <div className="space-y-1">
            {placeholders.map((placeholder) => (
              <div key={placeholder.name} className="text-sm">
                <code className="bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-200 px-1.5 py-0.5 rounded text-xs font-mono">
                  {placeholder.name}
                </code>
                <span className="text-blue-700 dark:text-blue-300 ml-2">
                  {placeholder.description}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaceholderHelper;